<template>
  <footer class="site-footer">
    <router-link to="/" class="footer-logo">
      <img :src="logoImage" alt="Acqtion" />
    </router-link>
    <div class="footer-right">
      <span class="footer-copy">© Acqtion NV. Alle rechten voorbehouden.</span>
      <ul class="footer-links">
        <li><router-link to="/privacybeleid">Privacybeleid</router-link></li>
        <li><router-link to="/disclaimer">Disclaimer</router-link></li>
        <li><router-link to="/cookies">Cookies</router-link></li>
      </ul>
    </div>
  </footer>
</template>

<script>
import logoImage from '@/assets/logo.png'

export default {
  name: 'SiteFooter',
  data() {
    return {
      logoImage
    }
  }
}
</script>

<style scoped>
.site-footer {
  padding: 48px var(--page-gutter, max(1.5rem, calc((100% - 1200px) / 2)));
  background: var(--ink, #2a2f35);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-logo img {
  height: 28px;
  width: auto;
  opacity: 0.5;
  filter: brightness(0) invert(1);
  transition: opacity 0.3s ease;
  display: block;
}

.footer-logo:hover img {
  opacity: 0.7;
}

.footer-right {
  display: flex;
  align-items: center;
  gap: 36px;
}

.footer-copy {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.3);
}

.footer-links {
  display: flex;
  gap: 28px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-links a {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.3);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: rgba(255, 255, 255, 0.6);
}

@media (max-width: 768px) {
  .footer-right {
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
  }
}
</style>
